import styled from 'styled-components';

export const FieldsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ButtonRow = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 24px;
  width: 100%;
`;

const BaseButton = styled.button`
  flex: 1;
  height: 44px;
  border-radius: 8px;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
`;

export const CancelButton = styled(BaseButton)`
  background: #ffffff;
  color: #0a0a0a;
  border: 1px solid #0000001a;

  &:hover {
    background: #f8f9fa;
  }
`;

export const SubmitButton = styled(BaseButton)`
  background: linear-gradient(90deg, #2a75e8 0%, #1f406e 100%);
  color: #ffffff;

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
`;
